import { Chip, FormControl, Grid, InputLabel, ListItemText, MenuItem, Select } from '@material-ui/core'
import { createTheme, makeStyles } from '@material-ui/core/styles'
import { Loader, Elements, models } from '@tfo/common'
import { PackagePriceData } from '@tfo/common/src/interfaces/PackagePrice'
import { useIntl } from "react-intl"
import React, { useEffect, useState } from 'react'
import $http from '../../../utils/$http'
import PackageTable from './PackagePriceTable'

const defaultTheme = createTheme()

const useStyles = makeStyles({
    tfoPinkChip: { backgroundColor: '#ec9dc9', color: '#f1f1f1' },
    tfoPinkColor: { color: '#ec9dc9' },
    container: { margin: '1rem 0', padding: '0 1rem' },
    comment: { border: 'rgba(0, 0, 0, 0.2) 1px solid', padding: '1rem', margin: ' 0 0.2rem', borderRadius: '4px' },
    commentAllignment: { justifyContent: 'flex-end', display: 'flex', maxHeight: '69px', overflow: 'auto' },
    filter: { [defaultTheme.breakpoints.down('xs')]: { width: '100%' } },
    noComment: { display: 'flex', flexDirection: 'row', justifyContent: 'center', margin: '1rem' }
})
const { Paragraph } = Elements
const CostsInfo = ({ companyId }: { companyId: number }) => {
    const [packageTableData, setPackageTableData] = useState<PackagePriceData>()
    const [selectedCompany, setSelectedCompany] = useState<number>(companyId)
    const [companyList, setCompanyList] = useState<Array<models.ICompany>>()
    const intl = useIntl()
    const classes = useStyles()
    useEffect(() => {
        if (companyId || selectedCompany) {
            getPackageTable()
        }
    }, [companyId, selectedCompany])

    useEffect(() => {
        getCompanyNames()
    }, [])

    const getPackageTable = async () => {
        const response = await $http.get<PackagePriceData>(`/order/servicepackage/price/${selectedCompany}`)
        const reportPackages = await $http.get<any>(`/order/service-packages/active/${selectedCompany}`)

        const result = reportPackages.filter(reportpackage => (!reportpackage.isIDD && !reportpackage.isGroupedOrder && !reportpackage.checkpoints.some(s => s.includes("International"))))
            .map(reportpackage => {
                return {
                    name: reportpackage.customName,
                    price: reportpackage.price,
                    days: reportpackage.daysToDeliver + ' ' + intl.formatMessage({ id: 'common.days' })
                }
            })

        response.packagePriceRows = result.concat(response.packagePriceRows)
        setPackageTableData(() => response)
    }

    const getCompanyNames = async (): Promise<void> => {
        const companies = await $http.get<any>(`/company/flat/${companyId}?subsidiaries=true`)
        const sortedList = companies.sort((a, b) => a.name.localeCompare(b.name))
        setCompanyList(() => sortedList)
    }

    return (
        <>
            {packageTableData ?
                <Grid container justifyContent='center' className={classes.container} >
                    <Grid container>
                        <Grid item xs={6}>
                            <FormControl variant="outlined" style={{ width: '20rem' }}>
                                <InputLabel id="company-label" >
                                    {intl.formatMessage({ id: 'controlpoint.company' })}
                                </InputLabel>
                                <Select
                                    id="company-select"
                                    labelId="company-label"
                                    value={selectedCompany}
                                    onChange={event =>
                                        setSelectedCompany(() => event.target.value as number)
                                    }
                                    label={intl.formatMessage({ id: 'controlpoint.company' })}
                                    variant="outlined"
                                    renderValue={
                                        () => {
                                            return <>
                                                {
                                                    <Chip className={classes.tfoPinkChip} label={companyList.find(c => c.id === selectedCompany).name} />
                                                }
                                            </>
                                        }
                                    }
                                >
                                    {companyList.map(
                                        company => (
                                            <MenuItem key={company.id} value={company.id}>
                                                <ListItemText primary={company.name} />
                                            </MenuItem>
                                        ),
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} className={classes.commentAllignment}>
                            {
                                packageTableData.comment !== "" &&
                                <div className={classes.comment}>
                                    <Paragraph>{packageTableData.comment}</Paragraph>
                                </div>
                            }
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        {
                            packageTableData.packagePriceRows.length > 0 ?
                                <PackageTable packagePriceRows={packageTableData.packagePriceRows} /> :
                                <div className={classes.noComment}>
                                    <Paragraph>{intl.formatMessage({ id: 'reportpackage.no.content' })}</Paragraph>
                                </div>
                        }
                    </Grid>
                </Grid>
                :
                <Loader></Loader>
            }
        </>
    )
}

export default CostsInfo